import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const ChecklistDefinitions = () => import('./pages/ChecklistDefinitions.vue');
const ChecklistsProcessControl = () => import('./pages/ChecklistsProcessControl.vue');
const ChecklistsQuality = () => import('./pages/ChecklistsQuality.vue');
const moduleRoutes = [
  {
    path: 'master-data/checklists',
    name: 'ChecklistDefinitions',
    component: ChecklistDefinitions,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.CHECKLISTS,
        action: USER_ACTIONS.READ,
      },
      isNextAppPage: true,
    },
  },
  {
    path: 'quality/checklists',
    name: 'QualityChecklists',
    component: ChecklistsQuality,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.CHECKLISTS,
        action: USER_ACTIONS.READ,
      },
      isNextAppPage: true,
    },
  },
  {
    path: 'process-control/checklists',
    name: 'ProcessControlChecklists',
    component: ChecklistsProcessControl,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.CHECKLISTS,
        action: USER_ACTIONS.READ,
      },
      isNextAppPage: true,
    },
  },
];

export default (router) => {
  for (let route of moduleRoutes) {
    router.addRoute(ROUTE_NAMES.BASE_LAYOUT, route);
  }
};
